


import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
}

function squareTransferVertical({ color }: Props): ReactElement {

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.66797 10.0003C1.66797 6.07195 1.66797 4.10777 2.88836 2.88738C4.10875 1.66699 6.07293 1.66699 10.0013 1.66699C13.9297 1.66699 15.8939 1.66699 17.1142 2.88738C18.3346 4.10777 18.3346 6.07195 18.3346 10.0003C18.3346 13.9287 18.3346 15.8929 17.1142 17.1133C15.8939 18.3337 13.9297 18.3337 10.0013 18.3337C6.07293 18.3337 4.10875 18.3337 2.88836 17.1133C1.66797 15.8929 1.66797 13.9287 1.66797 10.0003Z" stroke="#424242" />
            <path d="M8.33203 5.83366L8.33203 14.167L5.83203 11.3024" stroke="#424242" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.668 14.1663L11.668 5.83301L14.168 8.69759" stroke="#424242" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
export default squareTransferVertical;